<template>
  <el-container>
    <!--头部-->
    <el-header style="height: 60px;"><ks-header></ks-header></el-header>
    <!--中间部分-->
    <el-container>
      <!--左边栏-->
      <el-aside :width="isCollapse ? '64px' : '230px'" ><ks-aside :collapse="isCollapse"></ks-aside></el-aside>
      <!--显示内容区-->
      <el-container>
        <el-main>
          <!-- 主体 -->
          <el-header style="height:100px;">
            <!-- 头部导航栏 -->
            <div class="header-row">
              <!-- 折叠 展开  通知信息 -->
              <div class="toggle-button">
                <i :title="isCollapse ? '展开' : '收起'" class="fa fa-bars" @click="toggleCollapse"></i>
                <!--以下为系统公告地方-->

                <div style="height:25px;width:100%;margin-left:10px">
                  <div style="float:left;color:#E74405;font-size:16px;height:25px;line-height:25px;"><i class="fa fa-bullhorn"></i></div>
                  <el-carousel height="25px" direction="vertical" indicator-position="none" autoplay :interval="8000">
                    <el-carousel-item v-for="item in mottoList" :key="item">
                      <h3 class="medium">{{ item }}</h3>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
            <!-- tab标签页区域 - 用于标签页切换 -->
            <div class="tabs-switch-page">
              <el-row type="flex" class="row-bg" justify="space-between" style="width: 100%; text-align: left;">
                <el-col :span="22">
                  <el-tag
                    size="medium"
                    v-for="(tab, index) in tabList"
                    :key="tab.name"
                    @close="handleClose(tab, index)"
                    @click="changeMenu(tab)"
                    :closable="tab.name !== 'Home'"
                    :effect="activePath === tab.path ? 'dark' : 'plain'"
                  >
                    {{ tab.label }}
                  </el-tag>
                </el-col>
                <el-col :span="2" style="text-align: right;cursor: pointer;" >
                  <i class="fa el-icon-document-delete"  v-show="showAllClose"  @click="handleCloseAllTags()"><span style="font-size: 10px;">关闭所有</span></i>
                </el-col>
              </el-row>
            </div>
          </el-header>
          <!-- 内容区 -->
          <el-main>
            <!-- 路由占位符，用于展示内容区的内容 -->
            <div style="padding:5px">
              <keep-alive :include="catch_components"><router-view /></keep-alive>
            </div>
          </el-main>
        </el-main>
        <!--底部内容-->
        <el-footer><ks-footer></ks-footer></el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
    'ks-header': () => import('@/components/Header.vue'),
    'ks-aside': () => import('@/components/Aside.vue'),
    'ks-footer': () => import('@/components/Footer.vue')
  },
  // 组件被创建
  created () {
    // 加载菜单
  },
  computed: {
    ...mapState({
      // 从 state 中的到的计算属性
      activePath: state => state.activePath, // 已选中菜单
      tabList: state => state.tabList, // tags菜单列表
      catch_components: state => state.catch_components // keepalive缓存
    })
  },
  data () {
    return {
      // 折叠-展开 默认false不折叠
      isCollapse: false,
      showAllClose: true,
      // 系统公告
      mottoList: [
        '尼采、黑格尔、苏格拉底给了我们如婴儿降生般看世界机会',
        '当别人看到你成功的光芒后，就会忘记你手段的黑暗',
        '请叫我老刘,千万别带总,有幸带上曾经职业【老师】，那就是万谢千恩了',
        '人贵在有自知之明,欺骗自己比欺骗别人更可怕'
      ]
    }
  },
  methods: {
    // 点击折叠 展开菜单
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    // 关闭tab标签
    handleClose (tab, index) {
      // 历史选中菜单
      var oldActivePath = this.$store.state.activePath
      // 历史已选中菜单列表
      var oldTabList = this.$store.state.tabList
      // 计算标签个数
      let length = oldTabList.length - 1
      // 删除tabList中的该对象
      for (let i = 0; i < oldTabList.length; i++) {
        let item = oldTabList[i]
        if (item.name === tab.name) {
          oldTabList.splice(i, 1)
        }
      }
      // 删除keepAlive缓存
      this.$store.commit('removeKeepAliveCache', tab.path)
      // 如果关闭的标签不是当前路由的话，就不跳转
      if (tab.path !== oldActivePath) {
        return
      }
      // 如果length为1，必然只剩下首页标签，此时关闭后，更新到首页
      if (length === 1) {
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: '/home', tabList: oldTabList })
        // tab页向左跳转
        this.$router.push({ path: oldTabList[index - 1].path })
        // 不再向下执行
        return
      }
      // 关闭的标签是最右边的话，往左边跳转一个
      if (index === length) {
        // 同时更新路径
        oldActivePath = oldTabList[index - 1].path
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: oldActivePath, tabList: oldTabList })
        // tab页向左跳转
        console.log('==3===', oldTabList[index - 1].path)
        this.$router.push({ path: oldTabList[index - 1].path })
      } else {
        // 同时更新路径
        oldActivePath = oldTabList[index].path
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: oldActivePath, tabList: oldTabList })
        // tab页向右跳转
        this.$router.push({ path: oldTabList[index].path })
      }
    },
    // 点击标签跳转路由
    changeMenu (item) {
      // 历史选中菜单
      var oldActivePath = this.$store.state.activePath
      var curPath = item.path

      if (curPath === '/wellcome') {
        curPath = '/home'
      }

      // 首先判断点击的是否是自己，如果是自己则return
      if (oldActivePath === curPath) {
        return
      }
      // 不是自己，存储菜单
      this.$store.commit('changeMenu', curPath)
      // 页面跳转
      this.$router.push({ path: curPath })
    },
    handleCloseAllTags () {
      // 创建导航栏
      // clearVUEX
      this.$store.commit('clearVUEX') // 清理Tab
      var welcomePath = '/home' // 进入首页
      this.$router.push({ path: welcomePath })
      this.showAllClose = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.el-col-align-middle {
  line-height: 40px;
  text-align: left;
  font-size: 14px;
}
.home-container {
  height: 100%;
}
.el-header {
  color: rgb(0, 0, 0);
  font-size: 20px;
  border-bottom: 1px solid #dddddd;
  padding: 0;
  background: #fff;
}
.header-row {
  height: 60px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  overflow: hidden;
}
.header-avatar {
  float: right;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
  .user {
    font-size: 14px;
    font-weight: bold;
    padding: 0 10px;
  }
}

.el-aside {
  background-color: #282c34;
  .header-title {
    padding-left: 10px;
    height: 60px;
    font-weight: 300;
    display: flex;
    font-size: 20px;
    align-items: center;
    cursor: pointer;
    color: #ffffff;
    span {
      margin-left: 10px;
    }
  }
  .header-title-hiddle {
    width: 64px;
    height: 60px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
  }
  .el-menu {
    border-right: none;
  }
}
// 菜单选中背景色
.el-menu-item.is-active {
  background-color: #1890ff !important;
}
// 菜单悬浮背景色
.el-menu-item:hover {
  background-color: #1890ff !important;
}
// 走马灯
.el-carousel__item h3 {
  color: #ee7c12;
  font-size: 14px;
  opacity: 0.75;
  line-height: 25px;
  margin: 0;
}

.el-main {
  background-color: #eaedf1;
  padding: 0;
}

.fa {
  margin-right: 10px;
}

// 点击展开/折叠按钮
.toggle-button {
  width: 100%;
  font-size: 20px;
  line-height: 30px;
  color: #595959;
  text-align: left;
  display: flex;
  align-items: center;
  float: left;
  padding-left: 20px;
  i {
    cursor: pointer;
  }
}
// 面包屑导航
.el-breadcrumb {
  margin-bottom: 0;
}

// tab页
.tabs-switch-page {
  display: flex;
  align-items: center;
  height: 40px;
  background-color: #fff;
  overflow: hidden;
}
.el-tag {
  cursor: pointer;
  margin-left: 1px;
  border-radius: 3px;
  font-size: 12px;
  color: #1890ff;
  background-color: #fefefe;
  border-color: #1890ff;
}
.el-tag--dark {
  color: #fff;
  background-color: #1890ff;
}

.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.submit-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue